import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Section } from "@bpm/models";
import { Status } from "@common/models";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class SectionService {
  //EndPoint para controlador de este objeto en backend
  private sectionApiEndpoint = `${environment.bpmApiUrl}/api/sections`;

  constructor(private _http: HttpClient) {}

  //Obtiene todas las secciones
  getAllSections() {
    return this._http.get<Section[]>(this.sectionApiEndpoint);
  }

  //Obtiene la sección por su id
  getSectionById(sectionId: Number) {
    return this._http.get<Section>(`${this.sectionApiEndpoint}/${sectionId}`);
  }

  //Crea una nueva sección
  createNewSection(section: Section) {
    section.status = new Status();
    section.status.code = "ACT";

    return this._http.post<{ message: String; section: Section }>(
      this.sectionApiEndpoint,
      section
    );
  }

  //Actualiza la sección recibida
  updateSection(section: Section) {
    return this._http.put<{ message: String; section: Section }>(
      `${this.sectionApiEndpoint}/${section.id}`,
      section
    );
  }

  //Cambia el status de la sección
  changeSectionStatus(sectionId: Number, statusCode: String) {
    return this._http.put<{ message: String; section: Section }>(
      `${this.sectionApiEndpoint}/${sectionId}/${statusCode}`,
      null
    );
  }
/**
 * Funcion que retorna listado de secciones según el ID del proceso.
 * @param id ID del proceso
 * @returns 
 */
  getSectionByProcessId(id:number){
    return this._http.get<Section[]>(`${environment.bpmApiUrl}/api/sections-process/${id}`);

  }
}
